// @flow
import { EnlacesActionTypes } from './constants';

type EnlacesAction = { type: string, payload: {} | string };

// common success
export const enlacesApiResponseSuccess = (actionType: string, data: any): EnlacesAction => ({
    type: EnlacesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const enlacesApiResponseError = (actionType: string, error: string): EnlacesAction => ({
    type: EnlacesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getEnlace = (id: string): EnlacesAction => ({
    type: EnlacesActionTypes.GET_ENLACE,
    payload: { id },
});

export const addEnlace = (enlace:any):EnlacesAction=>({
    type:EnlacesActionTypes.ADD_ENLACE,
    payload:enlace
})
export const updateEnlace = (enlace:any):EnlacesAction=>({
    type:EnlacesActionTypes.UPDATE_ENLACE,
    payload:enlace
})
export const deleteEnlace = (id:string):EnlacesAction=>({
    type:EnlacesActionTypes.DELETE_ENLACE,
    payload:{id}
})

export const listEnlaces = (params:any): EnlacesAction => ({
    type: EnlacesActionTypes.LIST_ENLACES,
    payload: params,
});


export const resetEnlaces = (): EnlacesAction => ({
    type: EnlacesActionTypes.RESET,
    payload: {},
});

